import { MessageModal, ModalProps } from "@blacknut/react-sdk";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "src/theme/ThemeProvider";
import { useLinkAccountActivateGame } from "src/utils/useLinkAccountActivateGame";
import { AppLayout } from "core/redux";
import { useLayout } from "core/utils";
import { QRCodeModal } from "../QRCodeModal";

export const LinkAccountModal = (
  props: {
    onClose: () => void;
    url: string;
    headerElement?: JSX.Element;
  } & ModalProps,
) => {
  const { t } = useTranslation();
  const { url, headerElement } = props;
  const { theme } = useTheme();

  const isTV = useLayout() === AppLayout.TV;

  if (!isTV) {
    return (
      <MessageModal
        {...props}
        title={t("dialogs.error.linkAccount.title")}
        message={t("gameActivation.pending", { url })}
        positiveButtonText={t("dialogs.error.linkAccount.no")}
      />
    );
  }

  return (
    <QRCodeModal
      {...props}
      title={t("dialogs.error.linkAccount.title")}
      description={t("dialogs.error.linkAccount.message")}
      btnText={t("dialogs.error.linkAccount.no")}
      URL={url}
      theme={theme}
      headerElement={headerElement}
    />
  );
};

interface LinkAccountProps extends ModalProps {
  onClose: () => void;
  gameId: string;
  provider: string;
  origin?: string;
}

export const LinkAccountModalWithActivation = (props: LinkAccountProps) => {
  const { gameId, provider, origin, onClose } = props;
  const { url } = useLinkAccountActivateGame({
    gameId,
    provider,
    origin,
    onSuccess: onClose,
  });

  if (!url) {
    return <></>;
  }

  return <LinkAccountModal {...props} url={url} />;
};
